import "./stylesDeleteRoleModal.css";

import { CloseOutlined } from "@ant-design/icons";
import { AppStrings } from "../../../../../utils/constants/AppStrings";

function DeleteRoleModal({ role, handleCancel, handleDeleteRole }) {
  const onCancel = () => {
    handleCancel();
  };

  const onDelete = () => {
    handleDeleteRole();
  };
  return (
    <div className="delete-role-modal-container">
      <div className="delete-role-modal-header">
        <h2 className="delete-role-modal-header-title">{AppStrings.DELETE_THIS_ROLE}</h2>
        <CloseOutlined onClick={onCancel} className="delete-role-modal-close-icon" />
      </div>
      <div className="delete-role-modal-content">
        <p className="delete-role-modal-content-title">
          {AppStrings.ARE_YOU_SURE_YOU_WANT_TO_DELETE} "{role.name}" {AppStrings.ROLE}?
        </p>
      </div>
      <div className="delete-role-modal-divider" />
      <div className="delete-role-modal-footer">
        <button className="delete-role-modal-footer-button" onClick={onCancel}>
          {AppStrings.CANCEL}
        </button>
        <button className="delete-role-modal-footer-button" onClick={onDelete}>
          {AppStrings.DELETE}
        </button>
      </div>
    </div>
  );
}

export default DeleteRoleModal;
